// REDUCER
import * as actionTypes from '../constants/actions';

const defaultState = {
	items: formatAdImages(konfig.advertising) || [],
};

function formatAdImages(items) {
	let _items = [];
	for (let i = 0; i < items.length; i++) {
		if (
			(items[i].mobile1 && items[i].mobile1.normal && items[i].mobile1.normal.src) &&
			(items[i].mobile2 && items[i].mobile2.normal && items[i].mobile2.normal.src) &&
			(items[i].tablet1 && items[i].tablet1.normal && items[i].tablet1.normal.src) &&
			(items[i].tablet2 && items[i].tablet2.normal && items[i].tablet2.normal.src) &&
			(items[i].desktop1 && items[i].desktop1.normal && items[i].desktop1.normal.src) &&
			(items[i].desktop2 && items[i].desktop2.normal && items[i].desktop2.normal.src)
		) {
			let item = {
				url: items[i].link,
				image: {
					314: { span4: items[i].mobile1.normal.src },
					538: { span4: items[i].mobile2.normal.src },
					706: { span4: items[i].tablet1.normal.src },
					958: { span4: items[i].tablet2.normal.src },
					1126: { span4: items[i].desktop1.normal.src },
					1364: { span4: items[i].desktop2.normal.src },
				},
			};

			_items.push(item);
		}
	}

	return _items;
}

export default function adsReducer(state = defaultState, action) {
	switch (action.type) {
		default:
			return state;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/reducers/adverts.js
 **/